module.exports = __webpack_public_path__ + "img/comming-soon.6f60b68d.svg";